import { Dialog as BaseDialog } from '@base-ui/react/dialog';

type Props = {
  children: React.ReactNode;
  className?: string;
};

const DialogClose = ({ children, className }: Props) => {
  return (
    <BaseDialog.Close className={className}>{children}</BaseDialog.Close>
  );
};

export default DialogClose;
